module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "What's your favourite food?"
    }
  }, [_c('b-taginput', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable",
      value: (_vm.sortableOptions),
      expression: "sortableOptions"
    }],
    staticClass: "taginput-sortable",
    attrs: {
      "ellipsis": "",
      "icon": "label",
      "placeholder": "Add a food"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Tags:")]), _vm._v(" " + _vm._s(_vm.tags))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a4b9709e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/extensions/sortablejs/examples/ExSimple.vue
// module id = 1293
// module chunks = 38 45